import { rupees } from '../../api/upi';

const PERIOD_WORDS: Record<string, string> = { P1D: 'day', P1W: 'week', P1M: 'month', P3M: 'quarter', P1Y: 'year' };

/** A mandate's constraints as short phrases. */
export function describeTerms(c: Record<string, unknown>): string[] {
  const out: string[] = [];
  if (c.maxPerTxnPaise !== undefined) out.push(`Up to ${rupees(c.maxPerTxnPaise)} a payment`);
  if (c.maxPerDayPaise !== undefined) out.push(`${rupees(c.maxPerDayPaise)} a day`);
  if (c.maxPerPeriodPaise !== undefined) out.push(`${rupees(c.maxPerPeriodPaise)} a ${PERIOD_WORDS[String(c.period)] ?? String(c.period)}`);
  if (c.requireHumanAbovePaise !== undefined) {
    out.push(Number(c.requireHumanAbovePaise) === 0 ? 'You approve every payment' : `You approve payments above ${rupees(c.requireHumanAbovePaise)}`);
  }
  if (Array.isArray(c.allowedMerchantVPAs)) out.push(`Only to ${(c.allowedMerchantVPAs as string[]).join(', ')}`);
  if (Array.isArray(c.allowedMCCs)) out.push(`Merchant categories ${(c.allowedMCCs as string[]).join(', ')}`);
  return out;
}

export function shortDid(did: string): string {
  if (did.length <= 34) return did;
  return `${did.slice(0, 22)}…${did.slice(-8)}`;
}

export function formatDate(iso: string | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' });
}
